import React from 'react';

import s from './Logo.module.css';

const Logo = ({src}) => {
    return <img className={s.logo} src={src} alt="Logo"/>
}


export default Logo;